import React from "react";

const BarContext = React.createContext();

export default BarContext;
